import { Injectable } from '@angular/core';
import { AppService } from "src/app/services/app/app.service";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, retry } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private router: Router,private appService: AppService,) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return new Observable<boolean>((observer) => {
      window.addEventListener('message', (event) => {
        const topUrl = event.data?.topUrl;
        if (topUrl) {
          const parsedUrl = new URL(topUrl);
          const pathSegments = parsedUrl.pathname.split('/');
          const panelOfUtcAdmin = pathSegments[2];

          if (panelOfUtcAdmin.includes('panelofutcadmin')) {
            this.appService.setIsAdminValue(true);
            observer.next(true);  
            observer.complete();  
          } else {
            this.appService.setIsAdminValue(false);
            this.router.navigate(['/authentication/signin']);
            observer.next(false);  
            observer.complete();  
          }
        } else {
          this.appService.setIsAdminValue(false);
          this.router.navigate(['/authentication/signin']);
          observer.next(false);  
          observer.complete();  
        }
      });
    });
  }

}
